import {Directive, ElementRef, OnInit, Input, Component} from "@angular/core";
// tslint:disable-next-line:typedef
import * as $ from "jquery";
import * as jQuery from "jquery";
require("malihu-custom-scrollbar-plugin/jquery.mCustomScrollbar.concat.min.js");

@Directive({
    selector: "[scrollbar]",
    host: {"class":"mCustomScrollbar"},  // <-- Make sure you add the class
})
export class ScrollbarDirective implements OnInit {
    el: ElementRef;
    @Input() axis: string="xy";
    @Input() theme: string="inset-3";// "minimal-dark"
    @Input() position: string="inside";// "outside"
    @Input() alwaysShow: number=1;// 0,1,2
    @Input() buttonsEnabled: boolean=true;
    @Input() autoHide: boolean=false;
    @Input() updateOnContentResize: boolean=true;
    height: any;
    width: any;

    constructor(el:ElementRef) {
        this.el = el;
    }

    ngOnInit(): void  {
        // $(function(){ console.log('Hello'); }); <--TEST JQUERY
        // check if your plugins are loading
        // $().mousewheel) ? console.log('mousewheel loaded') : console.log('mousewheel not loaded');
        // $().mCustomScrollbar) ? console.log('mCustomScrollbar loaded') : console.log('mCustomScrollbar not loaded');
        $(this.el.nativeElement).mCustomScrollbar(<any>{
            axis:this.axis,
            autoHideScrollbar: this.autoHide,
            theme: this.theme,
            scrollbarPosition:"outside",
            alwaysShowScrollbar:1,
            scrollButtons:{
                enable: true
            },
            advanced:{
                autoExpandHorizontalScroll:true
            },
            mouseWheel:{
                enable: true
            },
            scrollInertia:150,
            updateOnContentResize: true

            // axis: this.axis,
            // autoHideScrollbar: this.autoHide,
            // theme: this.theme,
            // advanced: {
            //     updateOnContentResize: this.updateOnContentResize
            // },
            // scrollbarPosition: this.position,
            // alwaysShowScrollbar: this.alwaysShow, // 0,1,2
            // scrollButtons:{
            //     enable:this.buttonsEnabled
            // },
        });
        let scContent: any=$(this.el.nativeElement).find(".scrollContent");
        if(scContent && scContent.length && scContent.length>0) {
          this.height=$(scContent[0]).height();
          this.width=$(scContent[0]).width();
          console.log(`Width: ${this.width} Height: ${this.height}`);
          setInterval(()=> {
            let scContent: any=$(this.el.nativeElement).find(".scrollContent");
            let h: any=$(scContent[0]).height();
            let w: any=$(scContent[0]).width();
            if(h!==this.height || w!==this.width) {
              console.log(`Width: ${w} Height: ${h}`);

              $(this.el.nativeElement).mCustomScrollbar("update");
              this.width=w;
              this.height=h;
            }
          },200);
        }
  }
}